// extracted by mini-css-extract-plugin
module.exports = {"card-data":"ticketInfoDrawer_card-data__1cRHs","content-card":"ticketInfoDrawer_content-card__1OyZO","drawer":"ticketInfoDrawer_drawer__3pyKV"};